import * as constants from "./mediaAccountListConstants";

export const setSearchTerm = (searchTerm) => ({
    type: constants.SEARCH_ACCOUNTS,
    payload: { searchTerm },
});

export default setSearchTerm;
